/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_DownloadInputs */

const vi_action_download = /** @type {(inputs: Action_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tải về`)
};

/**

* @param {Action_DownloadInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const action_download = /** @type {((inputs?: Action_DownloadInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_DownloadInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_action_download(inputs)
});